import type { ShopSettings } from '../@models/shop-settings';

export const DEFAULT_SHOP_SETTINGS: Pick<
  ShopSettings,
  | 'version'
  | 'booking'
  | 'clients'
  | 'messaging'
  | 'notifications'
  | 'discovery'
  | 'scheduling'
  | 'checkIn'
  | 'locale'
> = {
  version: 1,
  booking: {
    enabled: true,
    onlineBookingEnabled: true,
    walkInsEnabled: true,
    requireClientAccount: false,
    allowGuestBooking: true,
    requirePhone: false,
    requireEmail: true,
    requireBookingConfirmation: false,
    allowSameDayBooking: true,
    minimumLeadTimeMinutes: 60,
    maximumAdvanceBookingDays: 60,
    cancellationWindowHours: 24,
    rescheduleWindowHours: 24,
    lateArrivalGraceMinutes: 10,
    slotIntervalMinutes: 15,
  },
  clients: {
    allowNewClients: true,
    allowFavorites: true,
    allowReviews: true,
    allowMessaging: true,
  },
  messaging: {
    enabled: true,
    appointmentMessagingEnabled: true,
    appointmentMessagingBeforeMinutes: 1440,
    appointmentMessagingAfterMinutes: 120,
  },
  notifications: {
    appointmentCreated: true,
    appointmentUpdated: true,
    appointmentCancelled: true,
    appointmentReminder: true,
    newReview: true,
    newMessage: true,
    staffChanges: true,
    push: true,
    email: true,
    sms: false,
    dailySummary: true,
  },
  discovery: {
    visibleInSearch: true,
    showReviews: true,
    showStaff: true,
    showPrices: true,
    showBusinessHours: true,
  },
  scheduling: {
    respectShopHours: true,
    allowOverbooking: false,
    allowDoubleBooking: false,
    bufferBetweenAppointmentsMinutes: 0,
  },
  checkIn: { enabled: true, qrEnabled: true, manualCodeEnabled: true, earlyCheckInMinutes: 15 },
  locale: {
    timezone: 'America/Puerto_Rico',
    language: 'es',
    currency: 'USD',
    dateFormat: 'MM/dd/yyyy',
    timeFormat: '12h',
  },
};

export function normalizeShopSettings(shopId: string, value?: Partial<ShopSettings>): ShopSettings {
  const settings = value ?? {};
  return {
    ...DEFAULT_SHOP_SETTINGS,
    ...settings,
    shopId,
    booking: { ...DEFAULT_SHOP_SETTINGS.booking, ...settings.booking },
    clients: { ...DEFAULT_SHOP_SETTINGS.clients, ...settings.clients },
    messaging: { ...DEFAULT_SHOP_SETTINGS.messaging, ...settings.messaging },
    notifications: { ...DEFAULT_SHOP_SETTINGS.notifications, ...settings.notifications },
    discovery: { ...DEFAULT_SHOP_SETTINGS.discovery, ...settings.discovery },
    scheduling: { ...DEFAULT_SHOP_SETTINGS.scheduling, ...settings.scheduling },
    checkIn: { ...DEFAULT_SHOP_SETTINGS.checkIn, ...settings.checkIn },
    locale: { ...DEFAULT_SHOP_SETTINGS.locale, ...settings.locale },
  } as ShopSettings;
}
